<template>

<div style="" v-show="isShow">
  <div id='neirong'  >
       <div class='cbo' style="margin-top:150px;font-size:23px;color:red"> 
       </div>
       <div class='cbo' style="margin-top:10px;font-size:23px;margin-bottom:-30px"> </div>
       <div class='cbo'>  <table style="border:0px">
            <tr>
              <td colspan="2" style="border:0px" ></td>
              <td colspan="2"  style="border:0px">报价单号：<input :readonly="isRedeoly"   v-model="data.clientAddr" style="width:80%"></td>
            </tr>
            <tr>
              <td colspan="2" style="border:0px" >客户名称 :<input :readonly="isRedeoly"  size="medium" v-model="data.clientName"  style="width:80%"></td>
              <td colspan="2"  style="border:0px">报价方：<input :readonly="isRedeoly"   v-model="data.clientAddr" style="width:80%"></td>
            </tr>
           <tr>
              <td colspan="2"  style="border:0px">联系人：<input :readonly="isRedeoly"    size="medium" v-model="data.clientName"  style="width:80%"></td>
              <td colspan="2"  style="border:0px">报价人：<input :readonly="isRedeoly"   v-model="data.clientAddr" style="width:80%"></td>
            </tr>
            <tr>
              <td colspan="2"  style="border:0px">电话：<input :readonly="isRedeoly"    size="medium" v-model="data.clientName"  style="width:80%"></td>
              <td colspan="2"  style="border:0px">电话：<input :readonly="isRedeoly"   v-model="data.clientAddr" style="width:80%"></td>
            </tr>
            <tr>
              <td colspan="2"  style="border:0px">邮箱E-mail：<input :readonly="isRedeoly"    size="medium" v-model="data.clientName"  style="width:80%"></td>
              <td colspan="2"  style="border:0px">邮箱：<input :readonly="isRedeoly"   v-model="data.clientAddr" style="width:80%"></td>
            </tr>
        </table> </div>
       <div class='cbo' style="margin-top:30px;font-size:23px;margin-bottom:-30px;line-height:50px">  
            尊敬的  <input :readonly="isRedeoly" maxlength="3800"  v-model="data.providePartsMaterial" size="15"  style='border:solid ;border-left:0px;border-top:0px;border-right:0px; margin-left:0px; height:30px;;outline:medium;font-size:21px;text-align:center'  >  先生/女士：  <br>
              &emsp;&emsp; 您好！感谢您对我实验室业务的垂询，以下是我们根据您的询价信息提供的报价。
       </div>
       <div class='cbo'> 
          <table style="table-layout:fixed;line-height:28px">
           <tr>
              <th style="width:5%">序号 </th>
              <th style="width:10%">样品名称 </th>
              <th style="width:15%">型号规格（样品描述）</th>
              <th style="width:5%" >数量 </th>
              <th style="width:28%" >检测项目 </th>
              <th style="width:30%">检测依据/测试条件 </th>
              <th style="width:8%">费用（RMB） </th>
            </tr>
            <tr v-for="(item,i) in list1" :key="i">
                <th >{{i+1}} </th>
                <th style="word-wrap:break-word;word-break:break-all">啊请稍等 </th>
                <th style="word-wrap:break-word;word-break:break-all">型号规格（样品描述）</th>
                <th style="word-wrap:break-word;word-break:break-all">数量 </th>
                <th style="word-wrap:break-word;word-break:break-all">检测项目 ,x.fgnb,mxcnv,,ssssssssssss111111111111111111111111111111111111111111111111</th>
                <th style="word-wrap:break-word;word-break:break-all">检测项目 ,x.fgnb,mxcnv,,ssssssssssss11111111111111111111111111111111111111111111111111</th>
                <th style="word-wrap:break-word;word-break:break-all"> 11 </th>
            </tr>
            <tr>
                <td colspan="5" ></td>
                <th >合计 </th>
                <td >{{total}}</td>
            </tr>
            <tr>
                <td colspan="7" rowspan="4">
                  <p>收款账户：</p>
                      <p>&emsp;&emsp;单位名称：工业和信息化部电子第五研究所</p>
                      <p>&emsp;&emsp;开户银行：中信银行广州分行</p>
                      <p>&emsp;&emsp;银行帐号：7443020183100002212</p>
                      <p>&emsp;&emsp;汇款时请备注“装备与整机研究部”和“报价单号”</p>
                  </td>
            </tr>
            <tr> </tr>
            <tr> </tr>
            <tr> </tr>
            <tr>
                <td colspan="7" >
                  付款方式：
                 </td>
            </tr>
            <tr>
                <td colspan="7" rowspan="4">
                    <p>备注：</p>
                    <p>&emsp;&emsp;1、此报价依据贵单位提供的询价信息给出，如实际委托时的要求与此报价单询价信息不符，将导致报价变化；</p>
                    <p>&emsp;&emsp;2、此报价不含重测费，如重测，按具体项目收费；</p>
                    <p>&emsp;&emsp;3、如项目进行过程中，委托方要求终止测试，则已测试的项目要收费；</p>
                    <p>&emsp;&emsp;4、此报价单有效期15天，超过15天未签字确认，则此报价失效；</p>
                </td>
            </tr>
            <tr> </tr>
            <tr> </tr>
            <tr> </tr>
            <tr>
                <td colspan="7" >&emsp;&emsp;如同意以上报价，请签字盖章后回传。此报价单将做为服务和收费依据。</td>
            </tr>
        </table> 
        </div>

        <div style="margin-top:30px;font-size:23px;margin-bottom:-30px" class='cbo'>  
          <div style="float:left;height:50px"><br>客户签字:</div>
          <div style="float:left;height:50px;border-bottom:2px solid black;width:150px" @click="imgDialog=true;">
            <img v-if="data.signaturelink" :src="data.signaturelink" style="width:150px;height:45px" />
          </div>
          <div style="float:right;height:50px;border-bottom:2px solid black;width:130px"><br>11<br></div>
          <div style="float:right;height:50px;"><br>报价人:</div><br><br>
          <div style="float:right;height:50px;"><br>工业和信息化部电子第五研究所装备与整机研究部</div>
          <br>&emsp;<br>&emsp;<br>&emsp;<br>&emsp;
        </div>
  </div>

  <div class ='divcenter'>
      <el-dialog title="授权人签名" :visible.sync="imgDialog" width="900px" :lock-scroll="false" >
        <esign :token="data.timeStamp+data.conId" :imgDialog="imgDialog" @callback="receiveSignature" />
      </el-dialog>
    </div>

    <div style="position:fixed; top:0;  z-index:999;width:100%;   background-color: #3e4753;   color:rgb(218, 213, 213) ;  ont-size: 14px; text-align:center;" >
      <div style="width:1000px;min-width:1000px; margin:0 auto;font-size:20px ;margin-top:10px;margin-bottom:15px"> 
          <span style="font-size:25px ;">报 价 单</span><br>
          <span >工业和信息化部电子第五研究所  （中  国  赛  宝  实  验  室）  装备与整机研究部</span><br>
          <div style="float:right;margin-top:-40px;"> <el-button :disabled="isRedeoly && data.signatureType!=='seeEdit'"  type="primary" @click="sava('暂存');">&emsp;暂存&emsp;</el-button></div>
          <div style="float:right;margin-right:-150px;margin-top:-40px;"> <el-button :disabled="isRedeoly && data.signatureType!=='seeEdit'"   type="primary" @click="submit('提交');">&emsp;提交&emsp;</el-button></div>
          <div style="float:left;margin-left:9%;margin-top:-62px;"> <img style="width:70px;height:70px"  src='../../assets/favicon.png'></div>
      </div>
    </div>
    <div style="position:fixed;   bottom:0;  z-index:999;width:100%;    background-color: #3e4753;   color:rgb(218, 213, 213) ;  font-size: 14px " >
      <div style="width: 50%;margin:0 auto;padding-top:10px;min-width:730px">
          <div style="float: right; margin-top:6px" ><a href="https://www.ceprei.com/index.html" ><img src="https://ca.ceprei.com/_nuxt/img/logo2-default.73cb0f3.png" ></a>  </div>
          <p  >Copyright © 2015. 中国赛宝实验室 All rights reserved. &nbsp;<i class="icon-home" ></i>&nbsp;广州市增城区朱村街朱村大道西78号 &nbsp;CEPREI-ZB-HT01-202102</p>
      </div>
  </div>
  </div>
</template>
<script>
import {  RequestPost } from '../../api/api'
import esign from '@/components/esign' 
import vueQr from 'vue-qr'
  export default {
  components: { esign ,vueQr},
    data() { 
       return {
         list1:[
            {name:''}, {name:''}, {name:''}, {name:''}, {name:''}
         ],
          data:{
            type:"",
            clientName:"",
            clientContacts:"",
            clientAddr:"",
            clientPhone:"",
            clientMail:"",
            clientFax:"",
            producerName:"",
            producerContacts:"",
            producerAddr:"",
            producerPhone:"",
            producerMail:"",
            producerFax:"",
            factoryName:"",
            factoryContacts:"",
            factoryAddr:"",
            factoryPhone:"",
            factoryMail:"",
            factoryFax:"",
            agentName:"",
            agentContacts:"",
            agentAddr:"",
            agentPhone:"",
            agentMail:"",
            agentFax:"",
            payerName:"",
            payerContacts:"",
            payerAddr:"",
            payerPhone:"",
            payerMail:"",
            payerFax:"",
            paymentMethod:"",
            paymentMethodOrder:"",
            payDate:"",
            receiverName:"",
            receiverContacts:"",
            receiverAddr:"",
            receiverPhone:"",
            receiverMail:"",
            receiverFax:"",
            subData:[],
            simpleSubmitMethod:"",
            simpleSubmitMethodOrder:"",
            providePartsMaterial:"",
            basis:"",
            items:"",
            conditionsRequirements:"",
            agreeSubcontract:"",
            lawsuit:"",
            reportType:"",
            reportForm:"",
            cmaCnas:"",
            serviceRequitements:"",
            reportRemark:"",
            sampleHandle:"",
            sampleHandleOrder:"",
            authorizer:'',
            authorizationTime:'',
            signaturelink:'',
            signer:'',
            signaturetime:'',
            openId:''
           },
          inputStyle:'',
          sampleInputStyle:'',
          sampleMethodInputStyle:'',
          imgDialog:false,
          isRedeoly:false,
          isShow:true,
          total:0
      };
    },
    watch : {

       
    },
    created:function(){
        document.title = '中国赛宝实验室装备与整机研究部委托书';
        this.total=0
        let prames='';
        try{
             prames = this.queryToObj(this.$route.fullPath)
        }catch(e){
          this.isShow=false
          this.$alert('无效地址,请确认',{dangerouslyUseHTMLString: true,lockScroll:false})
          throw e;
        }
        if(prames!==''){
          this.getData( prames);
        }
    },
    methods: {
     async getData(requestParam){
         await  RequestPost("/conSgin/get",requestParam).then(response => {
               if(response.data!='{}'){
                  this.data = JSON.parse(response.data);
               }
               this.data.reportType = this.getArr2(this.data.reportType);
               this.data.reportForm = this.getArr2(this.data.reportForm);
               this.data.cmaCnas = this.getArr2(this.data.cmaCnas);
               this.data.pageTye=requestParam.pageTye
               this.data.conId=requestParam.conId
               this.data.timeStamp=requestParam.timeStamp
               this.data.clientDept=requestParam.clientDept
               this.data.authorizer=requestParam.authorizer===undefined?'':requestParam.authorizer
               this.data.signatureType='edit'
               this.isRedeoly = (this.data.signatureType==='see'||this.data.signatureType==='seeEdit')?true:false
            }).catch(error => {
              console.log(error);
            })
      },
      getArr2(d){
          if(d===''||d===undefined)
              return [];
          return d.split(',');
      },
      receiveSignature (img){      // 接收组件的签名
          console.log(img);
          this.data.signaturelink =img.imgUrl;
          this.data.openId = img.openId
          console.log(this.data.openId);
          this.imgDialog = false;
      },
      queryToObj(base64str) {
        var decode = escape(atob(base64str.split('?')[1]));
        var str =   decodeURIComponent(decodeURIComponent(decode));
        const res = {}
        str.split('&').forEach(paramStr => {
          const arr = paramStr.split('=')
          const key = arr[0]
          const value = arr[1]
          res[key] = value
        })
        return res  
    },
    
      sava(type){
        // let data = JSON
        let data  = JSON.parse(JSON.stringify(this.data)); 
        data.commitType=type
        data.userId = ''
        data.id = ''
        RequestPost("/conSgin/save",data).then(response => {
					var obj=response['data'];
          var code=response['code'];
          var message=response['message'];
          if(code!=='0000'){
            this.$alert(type+'失败'+message,{dangerouslyUseHTMLString: true,lockScroll:false})
          }else{
              location.reload();
          }
				}).catch(error => {
			  	console.log(error);
          this.$alert(type+'失败',{dangerouslyUseHTMLString: true,lockScroll:false})
          
				})
      },
      // 提交
      submit  (type) {
        let msg = this.submitVerify();
        if(msg!==null){
          this.$message({ message:msg, type: "error" });
          return ;
        }
        this.sava(type);
      },
       
      initTime(date){
       if(typeof(date)=='string')
        return date;
        let year = date.getFullYear(); // 年
        let month = date.getMonth() + 1; // 月
         month = month < 10 ? "0" + month : month; // 如果只有一位，则前面补零
        let day = date.getDate(); // 日
        day = day < 10 ? "0" + day : day; // 如果只有一位，则前面补零
        return `${year}-${month}-${day}`;
    },
    }
  }
</script>
 </style>


// WEBPACK FOOTER //
// quoteSignature.vue?8fa24c24